import { notifications } from "@mantine/notifications"
import { AxiosError } from "axios"

import { queryClient } from "~/backend/queryClient"
import {
  findSupplierMappingQueryKey,
  useCreateSupplierMapping,
} from "~/gen/api/hooks"

export const useCreateSupplierMappingMutation = ({
  searchSupplier,
}: {
  searchSupplier: string
}) =>
  useCreateSupplierMapping({
    mutation: {
      onSuccess: async () => {
        notifications.show({
          title: "Supplier created",
          message: `Supplier created successfully`,
          color: "teal",
        })
        await queryClient.invalidateQueries(
          findSupplierMappingQueryKey({
            searchSupplier,
          })
        )
      },
      onError: (error) => {
        if (error instanceof AxiosError) {
          notifications.show({
            title: "Supplier create error",
            message: "Supplier create failed : " + error.response?.data,
            color: "red",
          })
        }
      },
    },
  })
